import React from 'react';
import LazyLoad from 'react-lazyload';
import { string } from 'prop-types';
import styles from './styles/styles.module.scss';
import { GERMAN } from '../../../../../utils/constants/language_region_codes';

const ActivitySuitabilityImage = ({ url, title, src, languageRegionCode }) => {
  return (
    <a href={url}>
      <div className={styles.container}>
        <div className={styles.opacCover} />
        <div className={`${styles.title} ${languageRegionCode === GERMAN ? styles.germanSizedText : ''}`}>{title}</div>
        <LazyLoad>
          <img className={styles.img} src={src} alt="" />
        </LazyLoad>
      </div>
    </a>
  );
};

ActivitySuitabilityImage.propTypes = {
  url: string.isRequired,
  title: string.isRequired,
  src: string.isRequired,
  languageRegionCode: string
};

ActivitySuitabilityImage.defaultProps = {
  languageRegionCode: 'en-US'
};

export default ActivitySuitabilityImage;
